import { createReduxModule } from '@skippay/core/utils/reduxUtils';

import { _MODULE_NAME } from './constants';
import reducer from './reducer';
import sagas from './sagas';

export * from './actions';
export * from './constants';
export * from './selectors';

export default createReduxModule(_MODULE_NAME, reducer, sagas);
